import React, { useState, useEffect } from 'react';
import { Select, Tooltip, Icon, Slider } from 'antd';
import { Container, DefaultZoom } from './styles';
import { DOCUMENT_TEMPLATES_MENUBAR } from '../MenuBar/translationValues';
import { useTranslation } from 'react-i18next';
import { useArtboardContext, CONTEXT_KEYS } from '../../../context/complexArtboardContext';

const { Option } = Select;
const NAMESPACES = ['DOCUMENT_TEMPLATES_MENUBAR'];

const defaultZoomOptions = ['fit', 25, 50, 75, 100];

const ZoomDropdown = ({ dropDownVisible }) => {
  const { t } = useTranslation(NAMESPACES);
  const [isVisible, setIsVisible] = useState(true);
  const defaultZoom = localStorage.getItem('defaultZoom');
  const [defaultZoomApplied, applyDefaultZoom] = useState(defaultZoom !== null);
  const [currentZoom, setCurrentZoom] = useState(100);

  const [, updateArtboard] = useArtboardContext(() => null, 'ZoomDropdown');

  const handleChange = (zoomValue, caller) => {
    if (caller === 'slider' && currentZoom === 'fit') return;
    setCurrentZoom(zoomValue);
    let actualZoomValue = zoomValue === 'default' ? localStorage.getItem('defaultZoom') : zoomValue;
    updateArtboard({ [CONTEXT_KEYS.SCALING_SETTING]: zoomValue !== 'fit' ? actualZoomValue / 100 : 'fit' });
    applyDefaultZoom(
      zoomValue === 'default' || zoomValue === defaultZoom || zoomValue === parseInt(defaultZoom),
    );
  };

  useEffect(() => {
    if (defaultZoom) {
      setCurrentZoom(defaultZoom);
      updateArtboard({ [CONTEXT_KEYS.SCALING_SETTING]: defaultZoom / 100 });
    }
  }, []);

  return (
    <Container>
      <Slider
        value={currentZoom !== 'fit' && parseInt(currentZoom)}
        disabled={false}
        min={10}
        max={500}
        onChange={value => handleChange(value, 'slider')}
      />
      <Tooltip
        placement="top"
        title={t(
          DOCUMENT_TEMPLATES_MENUBAR.ZOOM_DESIGN_TOOLTIP.key,
          DOCUMENT_TEMPLATES_MENUBAR.ZOOM_DESIGN_TOOLTIP.value,
        )}
        overlayStyle={{ visibility: !isVisible && 'hidden' }}
      >
        <Select
          defaultValue={currentZoom}
          value={currentZoom}
          onChange={value => handleChange(value, 'dropdown')}
          suffixIcon={<Icon type="shrink" />}
          onDropdownVisibleChange={e => {
            dropDownVisible(e);
            setIsVisible(!e);
          }}
        >
          <Option key="fit" value="fit">
            {t(
              DOCUMENT_TEMPLATES_MENUBAR.ZOOM_FIT_DROPDOWN_OPTION.key,
              DOCUMENT_TEMPLATES_MENUBAR.ZOOM_FIT_DROPDOWN_OPTION.value,
            )}
          </Option>
          {defaultZoom !== null && (
            <Option
              key="default"
              value={defaultZoomOptions.includes(defaultZoom) ? 'default' : defaultZoom}
            >
              {t(
                DOCUMENT_TEMPLATES_MENUBAR.ZOOM_DEFAULT_DROPDOWN_OPTION.key,
                DOCUMENT_TEMPLATES_MENUBAR.ZOOM_DEFAULT_DROPDOWN_OPTION.value,
              )}
            </Option>
          )}
          <Option key="25" value={25}>
            25%
          </Option>
          <Option key="50" value={50}>
            50%
          </Option>
          <Option key="75" value={75}>
            75%
          </Option>
          <Option key="100" value={100}>
            100%
          </Option>
        </Select>
      </Tooltip>
      <Tooltip
        placement="top"
        title={
          defaultZoomApplied
            ? t(
                DOCUMENT_TEMPLATES_MENUBAR.DEFAULT_ZOOM_TOOLTIP.key,
                DOCUMENT_TEMPLATES_MENUBAR.DEFAULT_ZOOM_TOOLTIP.value,
              )
            : t(
                DOCUMENT_TEMPLATES_MENUBAR.SET_ZOOM_DEFAULT_TOOLTIP.key,
                DOCUMENT_TEMPLATES_MENUBAR.SET_ZOOM_DEFAULT_TOOLTIP.value,
              )
        }
      >
        <DefaultZoom
          onClick={() => {
            localStorage.setItem('defaultZoom', currentZoom);
            applyDefaultZoom(true);
          }}
        >
          <Icon type={defaultZoomApplied ? 'check-circle' : 'info-circle'} />
        </DefaultZoom>
      </Tooltip>
    </Container>
  );
};

export default ZoomDropdown;
